import React from 'react';
import { MessageCircle, ClipboardCheck, Truck, ThumbsUp } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      icon: MessageCircle,
      number: "1",
      title: "Fale Conosco",
      description: "Envie uma mensagem no WhatsApp descrevendo o que você precisa. Respondemos em minutos!"
    },
    {
      icon: ClipboardCheck,
      number: "2",
      title: "Receba o Orçamento",
      description: "Orçamento grátis e sem compromisso. Preços justos e transparentes sempre!"
    },
    {
      icon: Truck,
      number: "3",
      title: "Atendimento Rápido",
      description: "Maioria dos serviços prontos no mesmo dia. Urgência? A gente resolve!"
    },
    {
      icon: ThumbsUp,
      number: "4",
      title: "Satisfação Garantida",
      description: "Garantia em todos os serviços. Seu problema não acabou? A gente volta até resolver!"
    }
  ];

  const whatsappNumber = "5585985195369";
  const whatsappMessage = "Olá! Gostaria de solicitar um orçamento.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section className="py-20 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-white/20 backdrop-blur-md rounded-full border border-white/30">
            <p className="text-white text-sm font-semibold">PROCESSO SIMPLES</p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Como Funciona? É Fácil e Rápido!
          </h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Do orçamento à entrega: transparência e agilidade em cada etapa
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div 
                key={index}
                className="relative"
              >
                {/* Connection Line (desktop only) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 left-1/2 w-full h-0.5 bg-white/30 z-0"></div>
                )}

                {/* Card */}
                <div className="relative bg-white/10 backdrop-blur-md border-2 border-white/30 rounded-2xl p-6 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2 h-full">
                  {/* Number Badge */}
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-[#f97316] rounded-full flex items-center justify-center shadow-xl border-4 border-white/20">
                    <span className="text-white font-bold text-xl">{step.number}</span>
                  </div>

                  {/* Icon */}
                  <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center mb-4 shadow-lg">
                    <IconComponent className="w-8 h-8 text-[#1e3a8a]" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-white/80 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <div className="inline-block bg-white/10 backdrop-blur-md border-2 border-white/30 rounded-2xl p-8">
            <p className="text-2xl font-bold text-white mb-4">
              Pronto para começar? É só chamar! 👋
            </p>
            <p className="text-lg text-white/80 mb-6">
              Atendemos Fortaleza e região com rapidez e qualidade
            </p>
            <button
              onClick={() => window.open(whatsappLink, '_blank')}
              className="bg-[#25D366] hover:bg-[#20BD5C] text-white font-bold px-10 py-4 rounded-xl text-lg shadow-2xl hover:shadow-[#25D366]/50 transition-all hover:scale-105 inline-flex items-center"
            >
              <MessageCircle className="w-6 h-6 mr-2" />
              Pedir Orçamento Grátis Agora
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
